<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <rmvue-grid  :columns="columns" :config="gridConfig" ></rmvue-grid>
  </div>
</template>
<script>
import rmvueGrid from '../components/rm-grid'

export default {
  name: 'Grid',
  components: {
    'rmvue-grid': rmvueGrid
  },
  data () {
    return {
      msg: 'Pay Grid',
      list: [],
      columns: [
        {
          name: 'Date',
          valueMapType: 'filter',
          filter: 'formatdate',
          value: 'created',
          sort_field: 'created'
        },
        {
          name: 'Name',
          value: function (data) {
            return (data.first_name ? data.first_name : '') + ' ' + (data.last_name ? data.last_name : '')
          },
          sort_field: 'first_name'
        },
        {
          name: 'Amount',
          valueMapType: 'filter',
          filter: 'currency',
          value: 'net_amount'
        },
        {
          name: 'Transaction Ref.',
          valueMapType: 'key',
          value: 'reference'
        },
        {
          name: 'Fare Media',
          valueMapType: 'key',
          value: 'fare_media_alias'
        },
        {
          name: 'Status',
          valueMapType: 'filter',
          filter: 'vGridStatus',
          value: 'status'
        },
        {
          name: 'Source',
          valueMapType: 'filter',
          filter: 'vGridButton',
          width: '200px',
          value: function () {
            return 'client_platform'
          }
        }
      ],
      gridConfig: {
        name: 'Payment Grid',
        proxy: true,
        url: this.ConfigService().api.payment_view.GET_PAYMENTS_V2,
        no_data_message: 'There are no smartcards available',
        pagination: {
          per_page: 5,
          page: 1
        },
        events: {
          onLoad: function (data) {
            console.log('onLoad', data)
          },
          onPaginate: function (page, pagination) {
            console.log('onPaginate', page)
          },
          onEntriesChange: function (entries) {
            console.log('onEntriesChange', entries)
          },
          onRowClick: function (row) {
            console.log('onRowClick', row)
          },
          onColumnClick: function (column) {
            console.log('onColumnClick', column)
          }
        }
      }
    }
  },
  mounted () {
    let vm = this
    vm.list = []
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Grid.vue